const yearSelect = document.getElementById('yearSelect');
const makeSelect = document.getElementById('makeSelect');
const modelSelect = document.getElementById('modelSelect');
const SearchBtnYMM = document.getElementById('ymm-serch-btn');
const VerifyBtnYMM = document.getElementById('ymm-verify-btn');
const ClearBtnYMM = document.getElementById('ymm-clear-btn');

let floor_mats_active = false;
if(document.querySelectorAll('.hide_variant_picker_cls').length > 0){
  floor_mats_active = true;
}

const baseUrl = "https://appdash.dashdesigns.info/api/get-ymm-list";
const probaseUrl = "https://appdash.dashdesigns.info/api/get-ymm-products-rows";
// const probaseUrl = "https://appdash.dashdesigns.info/api/get-ymm-products";
// const profitbaseUrl = "https://appdash.dashdesigns.info/api/get-fitment-products";

function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[()]/g, '')      // remove ( )
    .replace(/[^a-z0-9]+/g, '-') // replace spaces & symbols with -
    .replace(/^-+|-+$/g, '');   // trim hyphens
}
function updateATCButtonState() {
  // const inputs = document.querySelectorAll('.fitment-picker__option .variant-picker__option-values input');
  const inputs = document.querySelectorAll('.product-info__rowindex:not(.removed-row-data) .fitment-picker__option .variant-picker__option-values input');
  const atcButton = document.querySelector('.shopify-product-form .buy-buttons button[type="submit"]');
  
  if (!inputs.length || !atcButton) return;

  // 🔑 check if ANY input is checked
  const anyChecked = Array.from(inputs).some(input => input.checked);

  if (anyChecked) {
    const checkedInputs = Array.from(inputs).filter(input => input.checked);
    let hasBlankData = false;
    checkedInputs.forEach(input => {
      if(input.nextElementSibling.querySelectorAll('.pro-dropdown-menu li').length > 0){
        const fitmentVal = input.getAttribute('data-fitment-val')?.trim();
        const sku = input.getAttribute('data-sku')?.trim();
        if (!fitmentVal || !sku) {
          hasBlankData = true;
        }
      }
    });
    if (hasBlankData) {
      atcButton.classList.add('disabled', 'disabledchoose');
    } else {
      atcButton.classList.remove('disabled', 'disabledchoose');
    }
  } else {
    atcButton.classList.add('disabled');
    atcButton.classList.remove('disabledchoose'); // optional, remove old class if any
  }
}

// Brent Addition for auto selecting a single option with one variant
const selectSoloItem = (data) => {
  //console.log(data)
  if(data.length === 1 && data[0].styles.length === 1 && data[0].styles[0].fitments.length === 1) {
    const rowElements = document.getElementsByClassName('position-select-row')

    if(rowElements.length === 1) {
      const fitmentElement = rowElements[0].getElementsByClassName('block-swatch')
      if(fitmentElement.length === 1) {
        const selectedElement = fitmentElement[0]
        selectedElement.click()
      }
    }
  }
}

const $final_selection = () => {
  let yearVal = null;
  let makeVal = null;
  let modelVal = null;
  if(yearSelect.value.toLowerCase() !== 'year'){
    yearVal = yearSelect.value;
  }
  if(makeSelect.value.toLowerCase() !== 'make'){
    makeVal = makeSelect.value;
  }
  if(modelSelect.value.toLowerCase() !== 'model'){
    modelVal = modelSelect.value;
  }
  
  if (yearVal !== null && makeVal !== null && modelVal !== null ) {
    const handle = `${yearVal}+${makeVal}+${modelVal}`.toLowerCase().replace(/\s+/g, '-');
    if(VerifyBtnYMM){
      VerifyBtnYMM.disabled = false;
    }
    if(SearchBtnYMM){
      SearchBtnYMM.setAttribute("data-fatch",handle);
      SearchBtnYMM.disabled = false;
    }
  } else {
    if(SearchBtnYMM){
      SearchBtnYMM.setAttribute("data-fatch","");
      SearchBtnYMM.disabled = true;
    }
  }
}

// Start Get YMM Data Info Set in widget //
async function getYMMData({ year = "", make = "", model = "" } = {}) {
  if(SearchBtnYMM){ SearchBtnYMM.disabled = true; }
  if(VerifyBtnYMM){ VerifyBtnYMM.disabled = true; }
  let queryParams = new URLSearchParams({ year, make, model }).toString();  
  if(__st.p == "product"){
    const shopify_product_id = __st.rid;
    queryParams = new URLSearchParams({ year, make, model, shopify_product_id }).toString();
  }
  const url = `${baseUrl}?${queryParams}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const result = await response.json();
    /*if (result.success && result.data) {
      // Populate years
      if (!year && result.data.years) {
        yearSelect.innerHTML = '<option selected="">Year</option>';
        result.data.years.forEach(y => {
          const option = document.createElement("option");
          option.value = y;
          option.textContent = y;
          yearSelect.appendChild(option);
        });
        makeSelect.innerHTML = '<option selected="">Make</option>';
        modelSelect.innerHTML = '<option selected="">Model</option>';
      }

      // Populate makes
      if (year && !make && result.data.makes) {
        makeSelect.innerHTML = '<option selected="">Make</option>';
        result.data.makes.forEach(m => {
          const option = document.createElement("option");
          option.value = m;
          option.textContent = m;
          makeSelect.appendChild(option);
        });
        modelSelect.innerHTML = '<option selected="">Model</option>';
      }

      // Populate models
      if (year && make && result.data.models) {
        modelSelect.innerHTML = '<option selected="">Model</option>';
        result.data.models.forEach(dl => {
          const option = document.createElement("option");
          option.value = dl;
          option.textContent = dl;
          modelSelect.appendChild(option);
        });
        if(model){
          modelSelect.value = model;
        }
        $final_selection();
      }
    }*/
   if (result.success && result.data) {
      const storedYear = sessionStorage.getItem('selectedYear');
      const storedMake = sessionStorage.getItem('selectedMake');
      const storedModel = sessionStorage.getItem('selectedModel');

      if (!year && result.data.years) {
        if (storedYear && !result.data.years.some(item => item.toLowerCase() === storedYear.toLowerCase())) {
          return;
        }
        yearSelect.innerHTML = '<option selected="">Year</option>';
        result.data.years.forEach(y => {
          const option = document.createElement("option");
          option.value = y;
          option.textContent = y;
          yearSelect.appendChild(option);
        });

        makeSelect.innerHTML = '<option selected="">Make</option>';
        modelSelect.innerHTML = '<option selected="">Model</option>';
        if (storedYear) {
          yearSelect.value = storedYear;
        }
      }

      if (year && !make && result.data.makes) {
        if (storedMake && !result.data.makes.some(item => item.toLowerCase() === storedMake.toLowerCase())) {
          return;
        }
        makeSelect.innerHTML = '<option selected="">Make</option>';
        result.data.makes.forEach(m => {
          const option = document.createElement("option");
          option.value = m;
          option.textContent = m;
          makeSelect.appendChild(option);
        });

        modelSelect.innerHTML = '<option selected="">Model</option>';

        if (storedMake) {
          [...makeSelect.options].forEach(option => {
            if (option.value.toLowerCase() === storedMake.toLowerCase()) {
              makeSelect.value = option.value;
            }
          });
        }
        // if (storedMake) {
        //   makeSelect.value = storedMake;
        // }
      }

      if (year && make && !model && result.data.models) {
        if (storedModel && !result.data.models.some(item => item.toLowerCase() === storedModel.toLowerCase())) {
          return;
        }
        //modelSelect.innerHTML = '<option selected="">Model</option>';

        result.data.models.forEach(dl => {
          const option = document.createElement("option");
          option.value = dl;
          option.textContent = dl;
          modelSelect.appendChild(option);
        });
        
        if (model) {
          [...modelSelect.options].forEach(option => {
            if (option.value.toLowerCase() === model.toLowerCase()) {
              modelSelect.value = option.value;
            }
          });
        } else if (storedModel) {
          [...modelSelect.options].forEach(option => {
            if (option.value.toLowerCase() === storedModel.toLowerCase()) {
              modelSelect.value = option.value;
            }
          });
        }
        // if (model) {
        //   modelSelect.value = model;
        // } else if (storedModel) {
        //   modelSelect.value = storedModel;
        // }

        $final_selection();
      }
    }
  } catch (error) {
    console.error("Error fetching YMM data:", error);
  }
}
// End Get YMM Data Info Set in widget //

async function selectOption(listItem, optionText) {
  // listItem.closest('.block-swatch').click();
  const parent = listItem.closest('.product-info__block-item');
  parent.querySelectorAll('.block-swatch').forEach((el) => {
    el.classList.remove('active-swatch');
  }); 
  const currentSwatchitem = listItem.closest('.block-swatch');
  currentSwatchitem.click();
  if( optionText == 'Choose option' || optionText == 'Select Fitment' ){
    currentSwatchitem.classList.remove('active-swatch');
  }else{
    currentSwatchitem.classList.add('active-swatch');
  }
  const Fitsec = listItem.closest('.fitment-section-wrapp');
  const FitsecLabel = listItem.closest('label');
  const FitsecInput = FitsecLabel.previousElementSibling;
  const Maincont = listItem.closest('.product-info__rowindex');
  const dropdown = listItem.closest('.pro-dropdown-menu');
  const button = dropdown.previousElementSibling;
  button.querySelector('span').textContent = optionText;
  dropdown.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
  listItem.classList.add('selected');
  button.classList.remove('active');
  dropdown.classList.remove('show');

  let ComPrice = listItem.getAttribute('data-cpreice');
  let SelPrice = listItem.getAttribute('data-sprice');
  let variantId = listItem.getAttribute('data-var');
  let Fitvalinput = listItem.getAttribute('data-fitval');
  let Fitvalimg = listItem.getAttribute('data-img-cover');
  let DataConsolecover = listItem.getAttribute('data-consolecover');
  let DataSKU = listItem.getAttribute('data-sku');
  if(SelPrice > ComPrice){
    ComPrice = "";
  }
  if(variantId != '' && variantId != 'null'){
    FitsecInput.setAttribute('data-value',variantId);
  }else{
    FitsecInput.setAttribute('data-value',"");
  }
  if(Fitvalinput != '' && Fitvalinput != 'null'){
    FitsecInput.setAttribute('data-fitment-val',Fitvalinput);
  }else{
    FitsecInput.setAttribute('data-fitment-val',"");
  }
  if(Fitvalimg != '' && Fitvalimg != 'null'){
    FitsecInput.setAttribute('data-fitment-img',Fitvalimg);
    FitsecLabel.querySelector('.block-swatch-image').style.setProperty('--swatch-background', `url("${Fitvalimg}")`);
  }else{
    FitsecInput.setAttribute('data-fitment-img',"https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526");
    FitsecLabel.querySelector('.block-swatch-image').style.setProperty('--swatch-background', `url("https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526")`);
  }
  if(DataConsolecover != '' && DataConsolecover != 'null'){
    FitsecInput.setAttribute('data-consolecover',DataConsolecover);
  }else{
    FitsecInput.setAttribute('data-consolecover',"");
  }
  FitsecInput.setAttribute('data-sku', DataSKU);
  Maincont.setAttribute('data-sku', DataSKU);
  if(DataSKU != '' && DataSKU != 'null'){
    FitsecLabel.querySelector('.text-xs').innerText = `SKU: ${DataSKU}`;
  }
  if(FitsecInput.checked){
    if(Fitvalinput != '' && Fitvalinput != 'null'){
      Maincont.setAttribute('data-selectfit',Fitvalinput);
    }else{
      Maincont.setAttribute('data-selectfit',"");
    }
    if(DataConsolecover != '' && DataConsolecover != 'null'){
      Maincont.setAttribute('data-consolecover',DataConsolecover);
      if(Maincont.nextElementSibling.classList.contains('product-info__consolecover') && DataConsolecover == "true"){
        Maincont.nextElementSibling.classList.remove('hide-console-cover');
      }else{
        Maincont.nextElementSibling.classList.add('hide-console-cover');
      }
    }else{
      Maincont.setAttribute('data-consolecover',"");
      if(Maincont.nextElementSibling.classList.contains('product-info__consolecover')){
        Maincont.nextElementSibling.classList.add('hide-console-cover');
      }
    }
    if(Fitvalimg != '' && Fitvalimg != 'null'){
      Maincont.setAttribute('data-fitimage',Fitvalimg);
    }else{
      Maincont.setAttribute('data-fitimage',"https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526");
    }
    if(variantId != '' && variantId != 'null'){
      Maincont.setAttribute("data-selectvar",variantId);
    }else{
      Maincont.setAttribute("data-selectvar","");
    }
  }
  updateTotalPrice();
  updateATCButtonState();
  if (currentSwatchitem && currentSwatchitem.classList.contains('active-swatch')) {
    const gpocontainer = document.querySelector('.gpo-hidden-inputs');
    if (!gpocontainer) return;

    // 🔹 Get values safely
    const gpoPosition = currentSwatchitem.closest('.product-info__rowindex')?.getAttribute('data-position') || '';
    const gpoStyle = currentSwatchitem.previousElementSibling?.getAttribute('value') || '';
    const gpoFitment = currentSwatchitem.querySelector('.fit-dropdown-button .dropdown-title')?.innerText?.trim() || '';
    const gpoSku = currentSwatchitem.previousElementSibling?.getAttribute('data-sku') || '';

    const year = sessionStorage.getItem('selectedYear') || '';
    const make = sessionStorage.getItem('selectedMake') || '';
    const model = sessionStorage.getItem('selectedModel') || '';

    // 🔹 Prepare data
    const rawData = {
      Year: year,
      Make: make,
      Model: model,
      Fits: (year && make && model) ? `${year}/${make}/${model}` : '',
      Position: gpoPosition,
      Style: gpoStyle,
      Fitment: gpoFitment,
      Sku: gpoSku
    };

    // 🔹 Remove empty values
    const data = Object.fromEntries(
      Object.entries(rawData).filter(([_, value]) => {
        return value && value.toString().trim() !== '';
      })
    );

    // 🔥 Remove all previous auto-added inputs (avoid duplicates)
    gpocontainer.querySelectorAll('input[data-auto="true"]').forEach(el => el.remove());

    // 🔹 Add fresh inputs
    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.value = value;

      input.setAttribute('data-field-name', key);
      input.setAttribute('data-value', value);
      input.setAttribute('data-auto', 'true'); // 🔥 mark as script-generated

      gpocontainer.appendChild(input);
    });
  }
}

let container = "";
let ProductmainPrice = "";
let ProductmaincPrice = "";
let ProductVarid = "";

async function renderProductRows(productData) {
  container = document.querySelector('.product-grid-fitmentwrapper');
  const Consoledata = document.querySelector('.product-info__consolecover-js .info-consolecover-data');
  const Consoledatainfo = document.querySelector('.product-info__consolecover-js .info-consolecover-data-info');
  ProductmainPrice = Number(document.querySelector('buy-buttons .button').getAttribute('data-price'));
  ProductmaincPrice = Number(document.querySelector('buy-buttons .button').getAttribute('data-cprice'));
  ProductVarid = document.querySelector('.product-grid-fitmentwrapper').getAttribute('data-id');
  let ConsolePrice  = "";
  let ConsoleCPrice  = "";
  let ConsoleId  = "";
  let Consoleimg  = "";
  let Consoleinfocont  = "";
  container.innerHTML = '';
  if(Consoledata){
    ConsolePrice  = Consoledata.getAttribute('data-varprice');
    ConsoleCPrice  = Consoledata.getAttribute('data-varcprice');
    ConsoleId  = Consoledata.getAttribute('data-varid');
    Consoleimg  = Consoledata.getAttribute('data-image');
    Consoleimg  = Consoledata.getAttribute('data-image');
    if(!Consoleimg || Consoleimg.trim() === ''){
      Consoleimg = "https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526";
    }
  }
  if(Consoledatainfo){
    Consoleinfocont = Consoledatainfo.innerHTML;
  }

  productData.forEach((rowData, rowIndex) => {
    const position = rowData.position;
    const positionHandle = `position_${position.toLowerCase().replace(/\s+/g, '_')}`;
    let inputHTML = '';

    if(floor_mats_active){
      const floorVariants = window.GPOConfigs.product.variants
      if(floorVariants.length > 0) {
        const lowerPosition = position.toLowerCase()
        const searchTerm = lowerPosition.includes('cargo') ? 'cargo' : lowerPosition.includes('front') ? 'front' : lowerPosition.includes('2 row') ? '2 row' : '3 row'
        const selectedVariant = floorVariants.find(fv => fv.name.toLowerCase().includes(searchTerm))

        if(selectedVariant) {
          ProductmainPrice = Number(selectedVariant.price)
          ProductmaincPrice = Number(selectedVariant['compare_at_price'] || 0)
          ProductVarid = selectedVariant.id
        }
      }
      // if (handleize(rowData.position) === 'full-set-2-rows') {
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="full-set-2-rows"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="full-set-2-rows"]').value;
      // }
      // if (handleize(rowData.position) === 'full-set-3-rows') {
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="full-set-3-rows"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="full-set-3-rows"]').value;
      // }
      // if (handleize(rowData.position) === 'standard-cargo'){
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="cargo-mat"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="cargo-mat"]').value;
      // }
      // if (handleize(rowData.position) === 'front-set'){
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="front-set"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="front-set"]').value;
      // }
    }

    rowData.styles?.forEach((style, styleIndex) => {
      // Build a single input per style:
      const inputId   = `${positionHandle}_style_${styleIndex}_${rowIndex}`;
      const nameAttr  = `${positionHandle}`;
      // Use the first product of the first fitment as the “swatch” image & base price:
      const GridStyleName   = style.style_name;
      const primaryFit = style.fitments?.[0];
      const primaryProd  = primaryFit?.products?.[0] || {};
      let baseImage = primaryProd.product_img_url || '';
      let baseSKU = primaryProd.sku || '';
      const baseConsolecover = primaryProd.console_cover || '';
      const baseFitmentval = primaryFit.fitment_title || '';
      const basePrice  = primaryProd.price  || 0;
      if(!baseImage || baseImage.trim() === ''){
          baseImage = "https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526";
      }
      // Build the dropdown options from ALL fitments of this style:
      let dropdownTitle = 'Select fitment';
      let dropCount = style.fitments.length;
      let dropdownOptions = null;
      if(dropCount == 1 && (style.fitments[0].fitment_title === null || style.fitments[0].fitment_title === "")){
        dropdownOptions = null;
      }else{
        if(dropCount == 1){
          dropdownOptions = style.fitments.map((fitment, fitmentIndex) => {
            const prod = fitment.products?.[0] || {};
            const isSelected = fitmentIndex === 0 ? 'selected' : '';
            if (fitmentIndex === 0) dropdownTitle = fitment.fitment_title;

            return `
              <li class="${isSelected}"
                  data-consolecover="${prod.console_cover}" 
                  data-img-cover="${prod.product_img_url}" data-sku="${prod.sku}" data-fitval="${fitment.fitment_title}">
                ${fitment.fitment_title}
              </li>
            `;
          }).join('');
        }else{
          dropdownTitle = 'Select Fitment';
          dropdownOptions = `
            <li class="selected choose-option" 
                    data-consolecover="" 
                    data-img-cover=""
                    data-sku=""
                    data-fitval="">
              Choose option
            </li>
            ${style.fitments.map((fitment) => {
              const prod = fitment.products?.[0] || {};

              return `
                <li
                    data-consolecover="${prod.console_cover}" 
                    data-img-cover="${prod.product_img_url}"
                    data-sku="${prod.sku}"
                    data-fitval="${fitment.fitment_title}">
                  ${fitment.fitment_title}
                </li>
              `;
            }).join('')}
          `;
        }
      }
      inputHTML += `
        <input
          class="sr-only"
          type="radio"
          id="${inputId}"
          name="${nameAttr}"
          value="${GridStyleName}"
          data-fitment-img="${dropCount == 1 ? baseImage : ''}"
          data-fitment-val="${dropCount == 1 ? baseFitmentval : ''}"
          data-sku="${dropCount == 1 ? baseSKU : ''}"
          data-consolecover="${dropCount == 1 ? baseConsolecover : ''}"
          data-cprice="${ProductmaincPrice}"
          data-sprice="${ProductmainPrice}">
        <label class="block-swatch" for="${inputId}">
          <span class="checked-mark">
            <svg class="active-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
              <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
              <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
            </svg>
            <svg class="check-in-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
              <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
              <path d="M16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#B4A000"></path>
              <rect x="15.5" y="9" width="2.6" height="11" rx="1.3" fill="white"/>
              <circle cx="16.8" cy="23.5" r="1.6" fill="white"/>
            </svg>
          </span>
          <div class="text-xs">SKU: ${baseSKU}</div>
          <span
            class="block-swatch-image"
            style="--swatch-background: url(${baseImage});">
          </span>
          <div class="fitment-section-wrapp">
            <div class="fitment-section v-stack gap-2" style="${dropdownOptions === null ? 'display:none;' : ''}">
              <!--<p>Select fitment</p>-->
              <div class="dropdown-container">
                <button class="dropdown-button fit-dropdown-button">
                  <span class="dropdown-title">${dropdownTitle}</span>
                  <div class="dropdown-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                      <path d="M14.6667 9.36914L10.8473 13.1886L7.02786 9.36914" stroke="white" stroke-width="1.375"></path>
                    </svg>
                  </div>
                </button>
                <div class="pro-dropdown-menu">
                  <ul>
                    ${dropdownOptions}
                  </ul>
                </div>
              </div>
            </div>
            <price-list class="price-list sm:text-lg">
              <compare-at-price class="text-subdued line-through">
                <span class="sr-only">Regular price</span>
                <span class="pro">
                  ${
                    ProductmaincPrice > ProductmainPrice
                      ? window.$money_format(ProductmaincPrice, window.$shop_money_format)
                      : ''
                  }
                </span>
              </compare-at-price>
              <sale-price class="text-on-sale">
                <span class="sr-only">Sale price</span>
                <span class="prs">${ProductmainPrice ? window.$money_format(ProductmainPrice, window.$shop_money_format) : ''}</span>
              </sale-price>
            </price-list>
          </div>
        </label>
      `;
    });

    if (!inputHTML) {
      console.warn(`No styles found for ${position}`);
    }

    /* Row 509 => <legend class="text-subdued">Position:</legend>  **** -- Brent fix */
    const block = `
      <div
        class="product-grid-wrap product-info__block-item product-info__rowindex atc-product-variant"
        data-fatch-row="${positionHandle}"
        data-position="${position}"
        data-row-index="${rowIndex + 1}"
        data-block-id="custom_variant_picker_${rowIndex + 1}"
        data-block-type="custom-variant-picker-${rowIndex + 1}"
        data-price="${ProductmainPrice}"
        data-cprice="${ProductmaincPrice}"
        data-addvar="${ProductVarid}"
        data-selectvar="" data-selectfit="" data-fitimage="" data-selectstyle="" data-consolecover="" data-sku="">
        
        <div class="variant-picker__option-info info-removed-head">
          <div class="h-stack gap-2">
            <legend class="text-subdued">Fitment Option:</legend>
            <span>${position}</span>
          </div>
          <button class="remove-btn remove-row-btn">
            REMOVE ${position.toUpperCase()}
          </button>
        </div>
        
        <div class="variant-picker__option-info info-added-head">
          <div class="h-stack gap-2">
            <span>I don't want a ${position.toLowerCase()}.</span>
          </div>
          <button class="add-row add-row-btn" data-row="${rowIndex + 1}">
            ADD ${position.toUpperCase()}
          </button>
        </div>
        
        <fieldset class="fitment-picker__option">
          <div class="variant-picker__option-values position-select-row wrap gap-2">
            ${inputHTML}
          </div>
        </fieldset>
      </div>
      <div class="product-grid-wrap product-info__block-item product-info__consolecover atc-product-variant hide-console-cover" data-block-id="custom_variant_picker_${rowIndex + 1}" data-block-type="custom-variant-picker-${rowIndex + 1}" data-price="0" data-cprice="0">
        <div class="variant-picker__option_trigger">      
          <input class="checkbox console-selected-data-check" type="checkbox" id="console_cover_${rowIndex + 1}_trigger_box">
          <label class="block-swatch-triger" for="console_cover_${rowIndex + 1}_trigger_box">
            <div class="label-wrapp-header"><div class="label-wrapp-infocont"><p>Add console cover</p> <div class="bold console-price">${window.$money_format(ConsolePrice , window.$shop_money_format)}</div></div><div class="label-infocont-inn">${Consoleinfocont}</div></div>
            <span class="block-swatch__color" style="--swatch-background: url(${Consoleimg});"></span>
          </label>
        </div>
        <fieldset class="variant-picker__option">
          <div class="variant-picker__option-info">
            <div class="h-stack gap-2">
              <legend class="text-subdued">Console cover:</legend>
              <span>None</span>
            </div>
          </div>
      
          <div class="variant-picker__option-values console-select-row wrap gap-2">
            <input class="sr-only" type="radio" id="console_cover_${rowIndex + 1}_none" value="None" data-price-select="0" data-price-cselect="0" name="console_cover_${rowIndex + 1}" checked="checked">
            <label class="block-swatch console-card" for="console_cover_${rowIndex + 1}_none">
              <span class="checked-mark">
                <svg class="active-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
                  <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
                </svg>
                <svg class="check-in-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
                  <path d="M16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#B4A000"></path>
                  <rect x="15.5" y="9" width="2.6" height="11" rx="1.3" fill="white"/>
                  <circle cx="16.8" cy="23.5" r="1.6" fill="white"/>
                </svg>
              </span>
              <span class="block-swatch__color" style="--swatch-background: url(https://cdn.shopify.com/s/files/1/0698/1609/0787/files/image_15.png?v=1751611545);"></span>
              <p>None</p>
            </label>
            <input class="sr-only console-selected-data-iput" type="radio" id="console_cover_${rowIndex + 1}_none_console_box" value="Yes" data-price-select="${ConsolePrice}" data-price-cselect="${ConsoleCPrice}" name="console_cover_${rowIndex + 1}">
            <label class="block-swatch console-card console-selected-data-label" for="console_cover_${rowIndex + 1}_none_console_box">
              <span class="checked-mark ">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
                  <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
                </svg>
              </span>
              <span class="block-swatch__color" style="--swatch-background: url(${Consoleimg});"></span>
              <p>Add console cover</p>
              <div class="text-xs bold console-price">${window.$money_format(ConsolePrice , window.$shop_money_format)}</div>
            </label>
          </div>
        </fieldset>
      </div>
    `;
    container.insertAdjacentHTML('beforeend', block);
    attachRowHandlers();
  });
}
async function renderProductunRows(productData){
  container = document.querySelector('.product-grid-fitmentwrapper');
  ProductmainPrice = Number(document.querySelector('buy-buttons .button').getAttribute('data-price'));
  ProductmaincPrice = Number(document.querySelector('buy-buttons .button').getAttribute('data-cprice'));
  ProductVarid = document.querySelector('.product-grid-fitmentwrapper').getAttribute('data-id');
  container.innerHTML = '';
  const position = "Select Option";
  const positionHandle = `position_${position.toLowerCase().replace(/\s+/g, '_')}`;
  // Build a single input per style:
  const inputId   = `${positionHandle}_style`;
  const nameAttr  = `${positionHandle}`;
  let inputHTML = '';

  productData.forEach((rowData, rowIndex) => {
    // Use the first product of the first fitment as the “swatch” image & base price:
    const GridStyleName   = rowData.style_name.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    let baseImage = rowData.products[0].product_img_url || '';
    let baseSKU = rowData.products[0].sku || '';
    const baseConsolecover = '';
    const baseFitmentval = '';
    if(!baseImage || baseImage.trim() === ''){
        baseImage = "https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526";
    }
    if(floor_mats_active){
      // if (handleize(rowData.position) === 'full-set-2-rows') {
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="full-set-2-rows"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="full-set-2-rows"]').value;
      // }
      // if (handleize(rowData.position) === 'full-set-3-rows') {
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="full-set-3-rows"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="full-set-3-rows"]').value;
      // }
      // if (handleize(rowData.position) === 'standard-cargo'){
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="cargo-mat"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="cargo-mat"]').value;
      // }
      // if (handleize(rowData.position) === 'front-set'){
      //   ProductmainPrice = Number(document.querySelector('#variant-select-option option[data-titlehandle="front-set"]').getAttribute('data-price'));
      //   ProductVarid = document.querySelector('#variant-select-option option[data-titlehandle="front-set"]').value;
      // }
    }

    inputHTML += `
      <input
        class="sr-only"
        type="radio"
        id='${inputId}_${rowIndex}'
        name='${nameAttr}'
        value='${GridStyleName}'
        data-fitment-img='${baseImage}'
        data-sku="${baseSKU}"
        data-fitment-val='${baseFitmentval}'
        data-consolecover='${baseConsolecover}'
        data-cprice='${ProductmaincPrice}'
        data-sprice='${ProductmainPrice}'>
      <label class="block-swatch" for="${inputId}_${rowIndex}">
        <span class="checked-mark">
          <svg class="active-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
            <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
          </svg>
          <svg class="check-in-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
            <path d="M16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#B4A000"></path>
            <rect x="15.5" y="9" width="2.6" height="11" rx="1.3" fill="white"/>
            <circle cx="16.8" cy="23.5" r="1.6" fill="white"/>
          </svg>
        </span>
        <div class="text-xs">SKU: ${baseSKU}</div>
        <span
          class="block-swatch-image"
          style="--swatch-background: url(${baseImage});">
        </span>
        <div class="fitment-section-wrapp">
          <div class="fitment-style-content">
            <max-height class="max-height collection-banner--description" data-max="50" style="--max-height: 50px;">
              <div class="max-height--inner">
                <div class="max-height--inner-content rte">${rowData.style_name}</div>
              </div>
              <button class="max-height--toggle"><span class="text-button text-button--read-more">Read more</span><span class="text-button text-button--read-less">Read less</span></button>
            </max-height>
          </div>
          <price-list class="price-list sm:text-lg">
            <compare-at-price class="text-subdued line-through">
              <span class="sr-only">Regular price</span>
              <span class="pro">
                ${ ProductmaincPrice > ProductmainPrice ? window.$money_format(ProductmaincPrice, window.$shop_money_format) : '' }
              </span>
            </compare-at-price>
            <sale-price class="text-on-sale">
              <span class="sr-only">Sale price</span>
              <span class="prs">${ProductmainPrice ? window.$money_format(ProductmainPrice, window.$shop_money_format) : ''}</span>
            </sale-price>
          </price-list>
        </div>
      </label>
    `;

    if (!inputHTML) {
      console.warn(`No styles found for ${position}`);
    }
  });
  const block = `
    <div
      class="product-grid-wrap product-info__block-item product-info__rowindex atc-product-variant"
      data-fatch-row="${positionHandle}"
      data-position=""
      data-row-index="${position}"
      data-block-id="custom_variant_picker_1"
      data-block-type="custom-variant-picker-1"
      data-price="${ProductmainPrice}"
      data-cprice="${ProductmaincPrice}"
      data-addvar="${ProductVarid}"
      data-selectvar="" data-selectfit="" data-fitimage="" data-selectstyle="" data-consolecover="" data-sku="">
      
      <div class="variant-picker__option-info info-removed-head">
        <div class="h-stack gap-2">
          <legend class="text-subdued">Select Option:</legend>
        </div>
      </div>
      
      <fieldset class="fitment-picker__option">
        <div class="variant-picker__option-values position-select-row wrap gap-2">
          ${inputHTML}
        </div>
      </fieldset>
    </div>
  `;
  container.insertAdjacentHTML('beforeend', block);
  attachRowHandlers();
}

// Start Get Product Row Data Info //
async function getProductYMMData({ year = "", make = "", model = "", shopify_product_id = ""} = {}) {
  year = year || "";
  make = make || "";
  model = model || "";
  shopify_product_id = shopify_product_id || "";
  const queryParams = new URLSearchParams({ year, make, model, shopify_product_id }).toString();
  const url = `${probaseUrl}?${queryParams}`;
  
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const result = await response.json();
    if (result.success && result.data) {
      const Structured = result.data.structured;
      const UnStructured = result.data.unstructured;
      
      if(Array.isArray(Structured) && Structured.length !== 0){
        renderProductRows(Structured);
        updateATCButtonState();
        // Brent Add
        selectSoloItem(Structured);
      } else if(Array.isArray(UnStructured) && UnStructured.length !== 0){
        renderProductunRows(UnStructured);
        updateATCButtonState();
      } else{
        console.error("No data found.");
        const element = document.querySelector(".product-grid-fitmentwrapper-nodata");
        document.querySelector('.product-grid-fitmentwrapper').innerHTML = "";
        element.classList.remove("hide-nodata-error");
        const embElement = document.querySelector('[data-block-id="custom_embroidery"]')
        if(embElement) embElement.style.display = 'none'
        /*setTimeout(() => {
          element.classList.add("hide-nodata-error");
        }, 3000);*/
        updateATCButtonState();
      }
    }
    if (ClearBtnYMM) {
      ClearBtnYMM.style.display = 'flex';
    }
  } catch (error) {
    console.error("Error fetching YMM data:", error);
  }
}
// End Get Product Row Data Info //

// Start Session Selections YMM Data //
let year = "";
let make = "";
let model = "";
let shopify_product_id = "";
if(document.querySelector('.product-info__gettitle')){
  shopify_product_id = document.querySelector('.product-info__gettitle').getAttribute('data-pid');
}
async function restoreSessionSelections() {
  const storedYear = sessionStorage.getItem('selectedYear');
  const storedMake = sessionStorage.getItem('selectedMake');
  const storedModel = sessionStorage.getItem('selectedModel');

  if(document.querySelector('.yearselect-coll')){
    document.querySelector('.yearselect-coll').innerText = storedYear;
  }
  if(document.querySelector('.makeselect-coll')){
    document.querySelector('.makeselect-coll').innerText = storedMake;
  }
  if(document.querySelector('.modelselect-coll')){
    document.querySelector('.modelselect-coll').innerText = storedModel;
  }
  if(document.querySelector('.ymm-coll-bredcrumbs')){
    if(storedYear != null || storedMake != null || storedModel != null){
      document.querySelector('.ymm-coll-bredcrumbs').style.display = 'block';
    }else{
      document.querySelector('.ymm-coll-bredcrumbs').style.display = 'none';
    }
  }
  if(document.querySelector('.ymm-custom-element-products')){
    if(storedYear != null && storedMake != null && storedModel != null) {
      const Carname = storedYear + " " + storedMake + " " + storedModel;
      if(document.querySelector('.vehicle-selected-edite span')){
        document.querySelector('.vehicle-selected-edite span').innerText = Carname;
      }
      if(document.querySelector('.ymm-custom-element-products .search-container')){
        document.querySelector('.ymm-custom-element-products .search-container').classList.add('hide-data-selection');
      }
      if(document.querySelector('.ymm-custom-element-products .product-info__block-item')){
        document.querySelector('.ymm-custom-element-products .product-info__block-item').classList.add('activedata-selection');
      }
      
    }
  }
  
  // Always load years
  await getYMMData();
  if(yearSelect){
    if (storedYear) {
      year = storedYear;
      yearSelect.value = year;
      await getYMMData({ year });
      makeSelect.disabled = false;
      makeSelect.parentElement.classList.remove('disabled');
    }
  }
  if(makeSelect){
    if (storedMake) {
      make = storedMake;
      makeSelect.value = make;
      await getYMMData({ year, make });
      modelSelect.disabled = false;
      modelSelect.parentElement.classList.remove('disabled');
    }
  }
  if (modelSelect) {
    if (storedModel) {
      model = storedModel;
      // modelSelect.value = model;
      [...modelSelect.options].forEach(option => {
        if (option.value.toLowerCase() === model.toLowerCase()) {
          modelSelect.value = option.value;
        }
      });
      $final_selection();
    }
  }
   //Product On Load Call this
  if(document.querySelector('.product-info__gettitle')){
    year = storedYear;
    make = storedMake;
    model = storedModel;
    await getProductYMMData({ year, make, model, shopify_product_id});
  }
}
// End Session Selections YMM Data //



function updateTotalPrice() {
  let variantTotal = 0;
  let variantcurTotal = 0;

  // document.querySelectorAll('.atc-product-variant:not(.removed-row-data):not(.hide-console-cover)').forEach(el => {
  //   const price = parseFloat(el.getAttribute('data-price')) || 0;
  //   const cprice = parseFloat(el.getAttribute('data-cprice')) || 0;
  //   if (!isNaN(price) && price > 0) {
  //     variantTotal += price;
  //   }
  //   if (!isNaN(cprice) && cprice > 0) {
  //     variantcurTotal += cprice;
  //   }
  // });
  document.querySelectorAll('.product-info__rowindex:not(.removed-row-data)').forEach(el => {
    const checkedInput = el.querySelector('.variant-picker__option-values input:checked');
    if (checkedInput) {
      const price = parseFloat(el.getAttribute('data-price')) || 0;
      const cprice = parseFloat(el.getAttribute('data-cprice')) || 0;

      if (!isNaN(price) && price > 0) {
        variantTotal += price;
      }
      if (!isNaN(cprice) && cprice > 0) {
        variantcurTotal += cprice;
      }
    }
  });

  const buyButtons = document.querySelector('.product-info__block-item .buy-buttons button');
  if (!buyButtons) return;
  const btnbasePrice = parseFloat(buyButtons?.getAttribute('data-price')) || 0;
  const btnbasecPrice = parseFloat(buyButtons?.getAttribute('data-cprice')) || 0;
  if (variantTotal === 0) {
    variantTotal = btnbasePrice;
    variantcurTotal = btnbasecPrice;
  }
  const total = variantTotal;
  const Curtotal = variantcurTotal;
  const QTYdata = document.querySelector('.product-info__quantity-selector .quantity-selector__input').value;
  const Finaltotal = total * QTYdata;
  const Finalcurtotal = Curtotal * QTYdata;
  buyButtons.dataset.totalPrice = Finaltotal;
  buyButtons.dataset.totalcurrPrice = Finalcurtotal;
  if(!window.$money_format) return;
  const salePriceEl = buyButtons.querySelector('sale-price');
  const currPriceEl = buyButtons.querySelector('compare-at-price');
  if (!salePriceEl) return;
  if (salePriceEl) {
    salePriceEl.innerHTML = `<span class="sr-only">Sale price</span>`+window.$money_format(Finaltotal, window.$shop_money_format);
  }
  if (!currPriceEl) return;
  if (currPriceEl) {
    currPriceEl.innerHTML = `<span class="sr-only">Regular price</span>`+window.$money_format(Finalcurtotal, window.$shop_money_format);
  }
}

// Start Add And Remove Position row Button //
async function addRow(button) {
  const container = button.closest('.product-grid-wrap');
  if (!container) return;
  container.classList.remove('removed-row-data');
  if(container.getAttribute('data-consolecover') == "true"){
    container.nextElementSibling.classList.remove('hide-console-cover');
  }
  updateTotalPrice();
  updateATCButtonState();
}
async function removeRow(button) {
  const container = button.closest('.product-grid-wrap');
  if (!container) return;
  container.classList.add('removed-row-data');
  if(container.getAttribute('data-consolecover')){
    container.nextElementSibling.classList.add('hide-console-cover');
  }
  updateTotalPrice();
  updateATCButtonState();
}

function attachRowHandlers() {
  document.querySelectorAll('.add-row-btn').forEach(button => {
    button.removeEventListener('click', handleAddRow); // Prevent duplicate bindings
    button.addEventListener('click', handleAddRow);
  });

  document.querySelectorAll('.remove-row-btn').forEach(button => {
    button.removeEventListener('click', handleRemoveRow);
    button.addEventListener('click', handleRemoveRow);
  });
}

async function handleAddRow(event) {
  await addRow(event.currentTarget);
}

async function handleRemoveRow(event) {
  await removeRow(event.currentTarget);
}
// End Add And Remove Position row Button //

// Clear Error Message on Add to Cart Button //
function clearButtonErrorMsg() {
  const ErrorMsg = document.querySelector('.product-info__errormsg')
  if(ErrorMsg) ErrorMsg.classList.add('hide-errormsg')

  const submitButtons = document.querySelectorAll('button[type="submit"]')
  submitButtons.forEach((submitButton) => {
    submitButton.setAttribute("aria-busy", "false");
  });
}

document.addEventListener("DOMContentLoaded",async function () {
  const YMMModel = document.querySelector('.vehicle-select-wrapper');
  if (!YMMModel) return;

  // Year change
  if(yearSelect){
    yearSelect.addEventListener('change', async function () {
      clearButtonErrorMsg()
      year = this.value;
  
      sessionStorage.setItem('selectedYear', year);
      sessionStorage.removeItem('selectedMake');
      sessionStorage.removeItem('selectedModel');
  
      makeSelect.innerHTML = '<option selected="">Make</option>';
      modelSelect.innerHTML = '<option selected="">Model</option>';
      modelSelect.disabled = true;
      modelSelect.parentElement.classList.add('disabled');
  
      if (year !== '') {
        await getYMMData({ year });
        makeSelect.disabled = false;
        makeSelect.parentElement.classList.remove('disabled');
      } else {
        makeSelect.disabled = true;
        makeSelect.parentElement.classList.add('disabled');
      }
    });
  }
  // Make change
  if(makeSelect){
    makeSelect.addEventListener('change', async function () {
      clearButtonErrorMsg()
      
      make = this.value;
  
      sessionStorage.setItem('selectedMake', make);
      sessionStorage.removeItem('selectedModel');
  
      modelSelect.innerHTML = '<option selected="">Model</option>';
  
      if (make !== '') {
        await getYMMData({ year, make });
        modelSelect.disabled = false;
        modelSelect.parentElement.classList.remove('disabled');
      } else {
        modelSelect.disabled = true;
        modelSelect.parentElement.classList.add('disabled');
      }
    });
  }
  // Model change
  if(modelSelect){
    modelSelect.addEventListener('change',async function () {
      clearButtonErrorMsg()

      model = this.value;
      if (model !== '') {
        sessionStorage.setItem('selectedModel', model);
        $final_selection();
      } else {
        sessionStorage.removeItem('selectedModel');
      }
    });
  }

  var productId = window?.meta?.product?.id;
  if(productId == 8872851275939){
    sessionStorage.removeItem('selectedYear');
    sessionStorage.removeItem('selectedMake');
    sessionStorage.removeItem('selectedModel');
  }
  restoreSessionSelections();
  //updateTotalPrice();
  attachRowHandlers();
  const pathUrl = window.location.pathname;
  const CollectionhasTag = /^\/collections\/[^\/]+\/.+\+.+$/.test(pathUrl);
  if (CollectionhasTag) {
    setTimeout(() => {
      const targetSection = document.querySelector('.collection');
      if (targetSection) {
        const offset = targetSection.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }, 500);
  }

  // On Click SearchBtn Call this Home page and other page YMM widget
  if(SearchBtnYMM){
    SearchBtnYMM.addEventListener('click',async function () {
      window.location.href = SearchBtnYMM.getAttribute("data-surl")+'/'+SearchBtnYMM.getAttribute("data-fatch");
    });
  }

  // On Click VerifyBtn Call this
  if(VerifyBtnYMM){
    VerifyBtnYMM.addEventListener('click',async function () {
      clearButtonErrorMsg()
      year = yearSelect.value;
      make = makeSelect.value;
      model = modelSelect.value;
     shopify_product_id = document.querySelector('.product-info__gettitle').getAttribute('data-pid');
     await getProductYMMData({ year, make, model, shopify_product_id});
     updateTotalPrice();
     if(document.querySelector('.ymm-custom-element-products')){
        if(year != null && make != null && model != null) {
          const Carname = year + " " + make + " " + model;
          if(document.querySelector('.vehicle-selected-edite span')){
            document.querySelector('.vehicle-selected-edite span').innerText = Carname;
          }
          if(document.querySelector('.ymm-custom-element-products .search-container')){
            document.querySelector('.ymm-custom-element-products .search-container').classList.add('hide-data-selection');
          }
          if(document.querySelector('.ymm-custom-element-products .product-info__block-item')){
            document.querySelector('.ymm-custom-element-products .product-info__block-item').classList.add('activedata-selection');
          }
        }
      }
    });
  }
  
  // On Click ClearBtn Call this
  if(ClearBtnYMM){
    ClearBtnYMM.addEventListener('click',async function () {
      if(document.querySelector('.shopify-product-form .buy-buttons button[type="submit"]')){
        document.querySelector('.shopify-product-form .buy-buttons button[type="submit"]').classList.add('disabled');
      }
      if(document.querySelector('.product-grid-fitmentwrapper-nodata')){
        document.querySelector('.product-grid-fitmentwrapper-nodata').classList.add('hide-nodata-error')
      }
      const embElement = document.querySelector('[data-block-id="custom_embroidery"]')
      if(embElement) embElement.style.display = 'block'
      sessionStorage.removeItem('selectedYear');
      sessionStorage.removeItem('selectedMake');
      sessionStorage.removeItem('selectedModel');
      makeSelect.disabled = true;
      makeSelect.parentElement.classList.add('disabled');
      modelSelect.disabled = true;
      modelSelect.parentElement.classList.add('disabled');
      
      // Had to comment out the follwing line because it wasn't finding 'product-grid-fitmentwrapper',
      // so the innerHTML was erroring out and causing the script to not hit getYMMData
      //document.querySelector('.product-grid-fitmentwrapper').innerHTML = "";

      // Here's the replacement code   - Brent from Dash Designs
      const fitmentWrapper = document.querySelector('.product-grid-fitmentwrapper');
      if(fitmentWrapper) fitmentWrapper.innerHTML = "";
      
      if(SearchBtnYMM){
        SearchBtnYMM.disabled = true;
      }
      if(VerifyBtnYMM){
        VerifyBtnYMM.disabled = true;
      }
      await getYMMData();
      if(document.querySelector('.ymm-custom-element-products .search-container')){
        document.querySelector('.ymm-custom-element-products .search-container').classList.remove('hide-data-selection');
      }
      if(document.querySelector('.ymm-custom-element-products .product-info__block-item')){
        document.querySelector('.ymm-custom-element-products .product-info__block-item').classList.remove('activedata-selection');
      }
    });
  }
});
document.addEventListener('change', async function (event) {
  const optionTrigger = event.target.closest('.variant-picker__option_trigger');
  if (!optionTrigger) return;

  const checkEl = optionTrigger.querySelector('.console-selected-data-check');
  if (!checkEl) return;

  const optionValues = optionTrigger.nextElementSibling?.querySelector('.variant-picker__option-values');
  if (!optionValues) return;

  if (checkEl.checked) {
    const yesInputLabel = optionValues.querySelector('input[value="Yes"]')?.nextElementSibling;
    if (yesInputLabel) yesInputLabel.click();
  } else {
    const noneInputLabel = optionValues.querySelector('input[value="None"]')?.nextElementSibling;
    if (noneInputLabel) noneInputLabel.click();
  }
});
document.addEventListener('click', function(event) {
 if (!event.target.closest('.dropdown-container')) {
   document.querySelectorAll('.fit-dropdown-button').forEach(btn => {
     btn.classList.remove('active');
     btn.nextElementSibling.classList.remove('show');
   });
 }
});
document.addEventListener('change',async function (event) {
  event.preventDefault();
  
  if(floor_mats_active){
    const currentRow = event.target.closest('.product-info__rowindex');
    const currentFitment = currentRow.getAttribute('data-position');
    if (!currentRow) return;

    const currentInput = event.target;
    if (!currentInput.matches('input[type="checkbox"], input[type="radio"]')) return;

    const allRows = document.querySelectorAll('.product-info__rowindex');

    if(currentFitment !== 'Cargo mat'){
      allRows.forEach(row => {
        const inputcurrentFitment = row.getAttribute('data-position');
        if(inputcurrentFitment !== 'Cargo mat'){
          const input = row.querySelector('input[type="checkbox"], input[type="radio"]');

          if (input !== currentInput) {
            input.checked = false;
            row.classList.remove('acitve-row-prod');
          }
        }
      });
    }

    // Optional: add active class to current row
    if (currentInput.checked) {
      currentRow.classList.add('acitve-row-prod');
    }
  }
  
  // Check if the changed element is inside .position-select-row
  const positionSelectRow = event.target.closest('.position-select-row');
  const quantityUpdate = event.target.closest('.quantity-selector');
  if (quantityUpdate && event.target.tagName === 'INPUT') {
    updateTotalPrice();
  }
  if(document.querySelector('.product-info__gettitle')){
    shopify_product_id = document.querySelector('.product-info__gettitle').getAttribute('data-pid');
    if (positionSelectRow && event.target.tagName === 'INPUT') {
      const row_product_title = event.target.value;
      const row_product_console = event.target?.getAttribute('data-consolecover');
      const row_product_fitval = event.target?.getAttribute('data-fitment-val');
      const row_product_fitimg = event.target?.getAttribute('data-fitment-img');
      const row_product_price = event.target?.getAttribute('data-sprice');
      const row_product_cprice = event.target?.getAttribute('data-cprice');
      const row_product_sku = event.target?.getAttribute('data-sku');
      // Get the parent .product-info__rowindex
      const rowContainer = event.target.closest('.product-info__rowindex');
      const row_index = rowContainer?.getAttribute('data-row-index');

      rowContainer.classList.add('acitve-row-prod');
      rowContainer?.setAttribute('data-selectstyle',row_product_title);
      rowContainer?.setAttribute('data-selectfit',row_product_fitval);
      rowContainer?.setAttribute('data-fitimage',row_product_fitimg);
      rowContainer?.setAttribute('data-consolecover',row_product_console);
      rowContainer?.setAttribute('data-price',row_product_price);
      rowContainer?.setAttribute('data-cprice',row_product_cprice);
      rowContainer?.setAttribute('data-sku',row_product_sku);

      if(row_product_console){
        if(rowContainer.nextElementSibling.classList.contains('product-info__consolecover') && row_product_console == "true"){
          rowContainer.nextElementSibling.classList.remove('hide-console-cover');
        }else{
          rowContainer.nextElementSibling.classList.add('hide-console-cover');
        }
      }else{
        if(rowContainer.nextElementSibling){
          rowContainer.nextElementSibling.classList.add('hide-console-cover');
        }
      }
      updateTotalPrice();
      updateATCButtonState();
      const positionSelectRow = rowContainer.querySelector(".position-select-row");
    }
  }
});
document.addEventListener("click", function (event) {
  const button = event.target.closest(".fit-dropdown-button");
  if (!button) return; // Click not on a .fit-dropdown-button

  const container = button.closest(".dropdown-container");
  const dropdown = container?.querySelector(".pro-dropdown-menu");
  const isActive = button.classList.contains("active");

  // Remove 'active' and 'show' from all dropdowns
  document.querySelectorAll(".fit-dropdown-button").forEach(btn => {
    btn.classList.remove("active");
    const parentContainer = btn.closest(".dropdown-container");
    const menu = parentContainer?.querySelector(".pro-dropdown-menu");
    if (menu) menu.classList.remove("show");
  });

  // If not already active, activate this one
  if (!isActive && dropdown) {
    button.classList.add("active");
    dropdown.classList.add("show");
  }
});

document.addEventListener("click", function (event) {
  const li = event.target.closest(".pro-dropdown-menu ul li");
  if (!li) return;
  event.preventDefault(); // Prevents unwanted input focus or default behavior
  const labelText = li.textContent.trim();
  selectOption(li, labelText);
});
const colorContainer = document.querySelector('.meta-option-color');
if (colorContainer) {
  const variantOptions = colorContainer.querySelectorAll('.variant-opt-change');
  const colorPropertyInput = document.getElementById('selected-color-property');

  variantOptions.forEach(input => {
    input.addEventListener('change', (e) => {
      const selectedValue = e.target.value;
      const productImage = e.target.getAttribute("data-product-image");
      function updateVariantImage(variantImageUrl) {
        if (!variantImageUrl) return;

        const thumbnails = document.querySelectorAll('.product-gallery__thumbnail[data-image-meta]');
        thumbnails.forEach(btn => {
          const metaUrl = btn.dataset.imageMeta;
          if (metaUrl === variantImageUrl) {btn.click();}
        });
        /*
        const baseUrl = variantImageUrl.split('?')[0]; // Remove existing params
        const timestamp = Date.now(); // Use same timestamp for both

        // Update main gallery image
        const mainImg = document.querySelector('.product-gallery__media img');
        if (mainImg) {
          mainImg.src = `${baseUrl}?v=${timestamp}&width=570`;
          mainImg.srcset = [200, 300, 400, 500]
            .map(w => `${baseUrl}?v=${timestamp}&width=${w} ${w}w`)
            .join(', ');
        }
        */
        // Update thumbnail image
        // const thumbnailImg = document.querySelector('.product-gallery__thumbnail img');
        // if (thumbnailImg) {
        //   thumbnailImg.src = `${baseUrl}?v=${timestamp}&width=570`;
        //   thumbnailImg.srcset = [56, 64, 112, 128, 168, 192]
        //     .map(w => `${baseUrl}?v=${timestamp}&width=${w} ${w}w`)
        //     .join(', ');
        // }
      }

      // Usage remains the same
      updateVariantImage(productImage);

      colorContainer.querySelector('.variant-picker__option-info span').textContent = selectedValue;
      if (colorPropertyInput) {
        colorPropertyInput.value = selectedValue;
      }
    });
  });
}

document.addEventListener('click', function (e) {
  if (e.target.tagName === 'LABEL') {
    const containerFields = document.querySelectorAll('.product-grid-fitmentwrapper .product-grid-wrap.product-info__block-item:not(.product-info__consolecover)')
    containerFields.forEach(element => element.classList.remove('ymm-check-error'));

    const radioId = e.target.getAttribute('for');
    const radio = document.getElementById(radioId);
    if (radio && radio.type === 'radio' && !radio.checked) {
      e.preventDefault(); // prevent default focus and scroll
      e.target.blur();    // remove focus immediately
      radio.checked = true;

      const swatch = radio.nextElementSibling;
      if (!swatch) return;
      const fitmentWrap = swatch.querySelector('.fitment-section-wrapp');
      if (fitmentWrap) {
        const dropdownItems = fitmentWrap.querySelectorAll('.pro-dropdown-menu li');
        const dropdownTitleEl = fitmentWrap.querySelector('.fit-dropdown-button .dropdown-title');
        const dropdownTitle = dropdownTitleEl?.textContent?.trim();
        if (dropdownItems.length > 1) {
          if (dropdownTitle === 'Choose option' || dropdownTitle == 'Select Fitment') {
            swatch.classList.remove('active-swatch');
          } else {
            swatch.classList.add('active-swatch');
          }
        } else {
          swatch.classList.add('active-swatch');
        }
      }
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      if (swatch && swatch.classList.contains('active-swatch')) {
        const gpocontainer = document.querySelector('.gpo-hidden-inputs');
        if (!gpocontainer) return;

        // 🔹 Get values safely
        const gpoPosition = swatch.closest('.product-info__rowindex')?.getAttribute('data-position') || '';
        const gpoStyle = swatch.previousElementSibling?.getAttribute('value') || '';
        const gpoFitment = swatch.querySelector('.fit-dropdown-button .dropdown-title')?.innerText?.trim() || '';
        const gpoSku = swatch.previousElementSibling?.getAttribute('data-sku') || '';

        const year = sessionStorage.getItem('selectedYear') || '';
        const make = sessionStorage.getItem('selectedMake') || '';
        const model = sessionStorage.getItem('selectedModel') || '';

        // 🔹 Prepare data
        const rawData = {
          Year: year,
          Make: make,
          Model: model,
          Fits: (year && make && model) ? `${year}/${make}/${model}` : '',
          Position: gpoPosition,
          Style: gpoStyle,
          Fitment: gpoFitment,
          Sku: gpoSku
        };

        // 🔹 Remove empty values
        const data = Object.fromEntries(
          Object.entries(rawData).filter(([_, value]) => {
            return value && value.toString().trim() !== '';
          })
        );

        // 🔥 Remove all previous auto-added inputs (avoid duplicates)
        gpocontainer.querySelectorAll('input[data-auto="true"]').forEach(el => el.remove());

        // 🔹 Add fresh inputs
        Object.entries(data).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = value;

          input.setAttribute('data-field-name', key);
          input.setAttribute('data-value', value);
          input.setAttribute('data-auto', 'true'); // 🔥 mark as script-generated

          gpocontainer.appendChild(input);
        });
      }
    }
    if (radio.matches('.product-info__consolecover .sr-only[type="radio"], .product-info__consolecover .sr-only[type="checkbox"]')) {
      setTimeout(() => {
        if (radio.checked) {
          radio.closest('.variant-picker__option').querySelector('.variant-picker__option-info span').innerText = radio.nextElementSibling.querySelector('p').innerText
          const container = radio.closest('.product-info__consolecover');
          if (container) {
            let selectedColorEl = '';
            if(document.querySelector('.variant-picker__option.var_color')){
              selectedColorEl = document.querySelector('.variant-picker__option.var_color .variant-picker__option-info .selected-opt-value');
            }else{
              selectedColorEl = document.querySelector('.variant-picker__option.var_console-cover .variant-picker__option-info .selected-opt-value');
            }
            if (selectedColorEl) {
              const SelectedColor = selectedColorEl.innerText.trim();
              const SelectOpt = document.querySelector('#variant-select-option');

              if (!SelectOpt) {
                console.warn("Variant select element not found");
                return;
              }
              let combinedNo, combinedYes;
              if (SelectedColor.trim() === "No Console") {
                combinedNo = `No Console`;
                combinedYes = `With Console Cover`;
              } else {
                combinedNo = `${SelectedColor} / No Console`;
                combinedYes = `${SelectedColor} / With Console Cover`;
              }
              const matchingOption = Array.from(SelectOpt.options).find(opt => opt.text.trim() === combinedNo);
              const matchingOptionYes = Array.from(SelectOpt.options).find(opt => opt.text.trim() === combinedYes);
              const PriceOpt = matchingOption?.dataset.price || null;
              const CpriceOpt = matchingOption?.dataset.comprice || null;
              const PriceOptYes = matchingOptionYes?.dataset.price || null;
              const CpriceOptYes = matchingOptionYes?.dataset.comprice || null;
              const priceDifference = PriceOptYes - PriceOpt;
              const comparePriceDifference = CpriceOptYes - CpriceOpt;
              const savedPrice = priceDifference > 0 ? priceDifference : 0;
              const savedComparePrice = comparePriceDifference > 0 ? comparePriceDifference : 0;

              SelectOpt.setAttribute('main-price-select',PriceOpt);
              SelectOpt.setAttribute('main-price-compare',CpriceOpt);
              SelectOpt.setAttribute('console-price-select',savedPrice);
              SelectOpt.setAttribute('console-price-compare',savedComparePrice);
              document.querySelectorAll('.product-info__block-item.product-info__consolecover').forEach(block => {
                const yesInput = block.querySelector('.console-select-row input[value="Yes"]');
                if (yesInput) {
                  yesInput.setAttribute('data-price-select',savedPrice);
                  yesInput.setAttribute('data-price-cselect',savedComparePrice);
                  yesInput.nextElementSibling.querySelector('.console-price').innerText = window.$money_format(savedPrice, window.$shop_money_format);
                }
              });
              document.querySelectorAll('.product-info__consolecover.atc-product-variant').forEach(container => {
                const selectedInput = container.querySelector('input.sr-only:checked');
                const prevEl = container.previousElementSibling;

                if (!selectedInput || !prevEl) return;
                const isYes = selectedInput.value === 'Yes';
                const variant = isYes ? matchingOptionYes : matchingOption;

                if (variant) {
                  prevEl.setAttribute('data-addvar', variant.value);
                  prevEl.setAttribute('data-price', isYes ? PriceOptYes : PriceOpt);
                  prevEl.setAttribute('data-cprice', isYes ? CpriceOptYes : CpriceOpt);
                } else {
                  console.warn("No variant found for", isYes ? combinedYes : combinedNo);
                }
              });
            }
            container.dataset.selectvar = radio.value;
            container.dataset.price = radio.dataset.priceSelect;
            container.dataset.cprice = radio.dataset.priceCselect;
            updateTotalPrice();
            updateATCButtonState();
          }
        }
      }, 0);
    }
  }
});

/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));

      this.checkVisible();
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      this.classList.toggle('max-height--enabled');
    }
  }
  customElements.define('max-height', MaxHeight);
}

if(document.querySelector('#custom-embroidery')){
  document.querySelectorAll('#custom-embroidery').forEach(($this_checkbox) => {
    $this_checkbox.addEventListener('change', (event) => {
      event.preventDefault(), event.stopImmediatePropagation();
      if($this_checkbox.checked){
        if(document.querySelector('.custom_embroidery_section').classList.contains('default_hide_section')){
          document.querySelector('.custom_embroidery_section').classList.remove('default_hide_section');
        }
      } else{
        if(!document.querySelector('.custom_embroidery_section').classList.contains('default_hide_section')){
          document.querySelector('.custom_embroidery_section').classList.add('default_hide_section');
        }
      }
    });
  });
}


document.addEventListener('click', function (e) {
  const btn = e.target.closest(
    '.shopify-product-form .buy-buttons button[type="submit"].disabled'
  );

  if (!btn) return;

  // 🔴 Stop all events
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();

  // Find product form
  const form = btn.closest('.shopify-product-form');
  if (!form) return;

  // Prevent duplicate messages
  if (form.querySelector('.atc-error-message')) return;

  // Create message
  const msg = document.createElement('div');
  msg.className = 'atc-error-message';

  if(btn.classList.contains('disabledchoose')){
    msg.textContent = 'Select your fitment before adding to cart.';
  }else{
    const containerFields = document.querySelectorAll('.product-grid-fitmentwrapper .product-grid-wrap.product-info__block-item:not(.product-info__consolecover)')
    containerFields.forEach(element => element.classList.add('ymm-check-error'));
    msg.textContent = 'Please select Vehicle Fitment before adding to cart.';
  }
  

  // Insert message above button
  btn.parentNode.insertBefore(msg, btn);

  // Optional: auto remove after 3s
  setTimeout(() => {
    msg.remove();
  }, 3000);
}, true); 

// document.addEventListener('change', function (e) {
//   if (
//     e.target.closest('.variant-picker__option-values input')
//   ) {
//     updateATCButtonState();
//   }
// });

document.addEventListener('change', function (e) {
  if (e.target.matches('.variant-picker__option-values input')) {
    updateATCButtonState();
  }
  setTimeout(function () {
    const buttons = document.querySelectorAll('.disable-button-load');
    buttons.forEach(button => {
      button.classList.remove('disable-button-load');
    });
  }, 1000);
});
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const buttons = document.querySelectorAll('.disable-button-load');
    buttons.forEach(button => {
      button.classList.remove('disable-button-load');
    });
  }, 1000);
});